export enum BaseErrorCodesEnum {
  'error403' = 403,
  'error404' = 404,
}
